const STORAGE_KEYS = {
  ESTIMATES: 'service_calculator_estimates',
  TEMPLATES: 'service_calculator_templates'
};

// Save estimate to history
export const saveEstimate = (estimateData) => {
  try {
    const estimates = getEstimates();
    const newEstimate = {
      id: Date.now()?.toString(),
      timestamp: new Date()?.toISOString(),
      ...estimateData
    };
    estimates?.unshift(newEstimate);
    // Keep only last 50 estimates
    const trimmedEstimates = estimates?.slice(0, 50);
    localStorage.setItem(STORAGE_KEYS?.ESTIMATES, JSON.stringify(trimmedEstimates));
    return newEstimate;
  } catch (error) {
    console.error('Error saving estimate:', error);
    return null;
  }
};

// Get all estimates
export const getEstimates = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEYS?.ESTIMATES);
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error('Error loading estimates:', error);
    return [];
  }
};

// Delete estimate by ID
export const deleteEstimate = (id) => {
  try {
    const estimates = getEstimates();
    const filtered = estimates?.filter(est => est?.id !== id);
    localStorage.setItem(STORAGE_KEYS?.ESTIMATES, JSON.stringify(filtered));
    return true;
  } catch (error) {
    console.error('Error deleting estimate:', error);
    return false;
  }
};

// Save template
export const saveTemplate = (templateData) => {
  try {
    const templates = getTemplates();
    const newTemplate = {
      id: Date.now()?.toString(),
      createdAt: new Date()?.toISOString(),
      ...templateData
    };
    templates?.unshift(newTemplate);
    localStorage.setItem(STORAGE_KEYS?.TEMPLATES, JSON.stringify(templates));
    return newTemplate;
  } catch (error) {
    console.error('Error saving template:', error);
    return null;
  }
};

// Get all templates
export const getTemplates = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEYS?.TEMPLATES);
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error('Error loading templates:', error);
    return [];
  }
};

// Delete template by ID
export const deleteTemplate = (id) => {
  try {
    const templates = getTemplates();
    const filtered = templates?.filter(tpl => tpl?.id !== id);
    localStorage.setItem(STORAGE_KEYS?.TEMPLATES, JSON.stringify(filtered));
    return true;
  } catch (error) {
    console.error('Error deleting template:', error);
    return false;
  }
};

// Update template
export const updateTemplate = (id, updates) => {
  try {
    const templates = getTemplates();
    const index = templates?.findIndex(tpl => tpl?.id === id);
    if (index !== -1) {
      templates[index] = { ...templates?.[index], ...updates, updatedAt: new Date()?.toISOString() };
      localStorage.setItem(STORAGE_KEYS?.TEMPLATES, JSON.stringify(templates));
      return templates?.[index];
    }
    return null;
  } catch (error) {
    console.error('Error updating template:', error);
    return null;
  }
};

// Search estimates
export const searchEstimates = (query) => {
  const estimates = getEstimates();
  if (!query) return estimates;
  
  const lowerQuery = query?.toLowerCase();
  return estimates?.filter(est => 
    est?.name?.toLowerCase()?.includes(lowerQuery) ||
    est?.projectName?.toLowerCase()?.includes(lowerQuery) ||
    est?.notes?.toLowerCase()?.includes(lowerQuery)
  );
};

// Search templates
export const searchTemplates = (query) => {
  const templates = getTemplates();
  if (!query) return templates;
  
  const lowerQuery = query?.toLowerCase();
  return templates?.filter(tpl => 
    tpl?.name?.toLowerCase()?.includes(lowerQuery) ||
    tpl?.description?.toLowerCase()?.includes(lowerQuery)
  );
};